export const SCAN_TRANSLATIONS = {
  en: {
    // Field labels
    label: "Name",
    serialNumber: "Serial Number",
    assignedTo: "Assigned To",
    city: "City",
    address: "Address",
    floor: "Floor",
    office: "Office",

    // Messages
    loadingContent: "Loading content",
    noInventoryFound: "There is no inventory with the requested identification number",
    noActiveCensus: "There is no currently active inventory check",
    alreadyCensused: "Inventory has already been counted for the currently active inventory check",
    willBeAdded: "This inventory will be added to the currently active inventory check",

    // Warnings
    itemHasParts: "This item has parts that are counted individually. Please count all parts by scanning their QR codes.",
    markedProblematicFields: "Marked problematic fields:",

    // Field marking
    incorrect: "Incorrect",
    markAsIncorrect: "Mark as incorrect",

    // Feedback section
    additionalComment: "Additional comment (optional):",
    commentPlaceholder: "Describe the problem or suggest a correction...",

    // Actions
    areDataCorrect: "Is the data about this item correct?",
    allCorrect: "All Correct",
    confirmProblems: "Confirm Problems",

    // Alerts and validation
    markFieldsOrComment: "Please mark problematic fields or leave a comment.",
    successfullyAdded: "Inventory has been successfully registered for inventory check",
    errorAdding: "Error registering inventory. Please try again.",

    // Description compilation
    problematicFields: "Problematic fields:",
    comment: "Comment:"
  },
  sr: {
    // Field labels
    label: "Naziv",
    serialNumber: "Serijski broj",
    assignedTo: "Dodeljeno kolegi",
    city: "Grad",
    address: "Adresa",
    floor: "Sprat",
    office: "Kancelarija",

    // Messages
    loadingContent: "Sadržaj se učitava",
    noInventoryFound: "Ne postoji inventar sa traženim evidencionim brojem",
    noActiveCensus: "Ne postoji trenutno aktivan popis",
    alreadyCensused: "Inventar je već popisan za trenutno aktivni popis",
    willBeAdded: "Ovaj inventar će biti dodat u trenutno aktivni popis",

    // Warnings
    itemHasParts: "Ovaj predmet ima delove koji se popisuju pojedinačno. Molimo vas da popišete sve delove skeniranjem njihovih QR kodova.",
    markedProblematicFields: "Označena problematična polja:",

    // Field marking
    incorrect: "Netačno",
    markAsIncorrect: "Označite da je netačan",

    // Feedback section
    additionalComment: "Dodatni komentar (opciono):",
    commentPlaceholder: "Opišite problem ili predložite ispravku...",

    // Actions
    areDataCorrect: "Da li su podaci o ovom predmetu tačni?",
    allCorrect: "Sve je tačno",
    confirmProblems: "Potvrdi probleme",

    // Alerts and validation
    markFieldsOrComment: "Molimo vas da označite problematična polja ili ostavite komentar.",
    successfullyAdded: "Inventar je uspešno zaveden za popis",
    errorAdding: "Greška pri zavođenju inventara. Pokušajte ponovo.",

    // Description compilation
    problematicFields: "Problematična polja:",
    comment: "Komentar:"
  }
};
